import React, {Fragment, useState} from "react";

import HookSubFormChildDetails from "root/Base/HookFormComponents/HookSubFormChildDetails";
import {SaveButton} from "root/Modals/SaveButton";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import { FormInputCheckbox } from "../ReactHookForm/FormComponents";
import ReturningChildForm from "root/NewToLAC/ReturningChildForm";
import NewChildForm from "root/NewToLAC/NewChildForm";

const Page1 = ({notify}) =>
{
    const [isReturning, setIsReturning] = useState(true);
    const [isNew, setIsNew] = useState(false);

    const onCheckboxChangeReturning = (state) =>
    {
        setIsReturning(state);
        setIsNew(!state);
    }

    const onCheckboxChangeNew = (state) =>
    {
        setIsNew(state);
        setIsReturning(!state);
    }

    const newSection = () =>
    {
        return (
            <Fragment>
                <form className='' onSubmit={handleSubmit(onSubmit)}>

                    <HookSubFormChildDetails key='childDetailForm' {...controlProps} search={false} sectionName='header' isPost16={isPost16()} />

                    <div className="button-row top-margin">
                        <SaveButton disabled={false} onClick={onClickSearch} kay={'sb'}>Check Pupil Name</SaveButton>
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <Fragment>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <FormInputCheckbox readOnly={false} label='Is this pupil returning to care?' name={'returning'} value={isReturning} onChange={onCheckboxChangeReturning}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputCheckbox readOnly={false} label='Or is it a new pupil' name={'new'} value={isNew} onChange={onCheckboxChangeNew}/>
                </BootstrapCol>
            </BootstrapRow>

            {isReturning === true && <ReturningChildForm notify={notify} /> }
            {isReturning === false && <NewChildForm notify={notify} /> }

        </Fragment>

    )
}

export default Page1 ;